(() => {
  if (window.__lexieSlideshowMotionInstalled) return;
  window.__lexieSlideshowMotionInstalled = true;

  const sectionSelector = '[id$="__slideshow_8e4tYA"]';
  const editorialEase = [0.16, 1, 0.3, 1];

  const installTransparentHeaderTracking = () => {
    const section = document.querySelector(sectionSelector);
    const header = document.querySelector(".shopify-section--header .header");

    if (!section || !header) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        header.classList.toggle("lexie-over-slideshow", entry.isIntersecting);
      },
      { threshold: 0.01 }
    );

    observer.observe(section);
  };

  installTransparentHeaderTracking();

  const animationGroup = (animations) => {
    const finished = Promise.all(
      animations.map((animation) => animation.finished.catch(() => undefined))
    ).then(() => {
      animations.forEach((animation) => animation.cancel());
    });

    return {
      finished,
      finish() {
        animations.forEach((animation) => animation.finish());
      }
    };
  };

  const animateElements = (definitions) => {
    const animations = definitions
      .filter(({ element }) => element)
      .map(({ element, keyframes, options }) =>
        element.animate(keyframes, { fill: "both", ...options })
      );

    return animationGroup(animations);
  };

  const getMotionParts = (slide) => ({
    image: slide.querySelector(".content-over-media > picture img"),
    heading: slide.querySelector(".prose > :is(.h1, .h6)")
  });

  customElements.whenDefined("slideshow-carousel").then(() => {
    const Carousel = customElements.get("slideshow-carousel");
    const originalMotion = Carousel.prototype.createOnChangeAnimationControls;

    Carousel.prototype.createOnChangeAnimationControls = function (
      fromSlide,
      toSlide,
      options = {}
    ) {
      if (
        !this.closest(sectionSelector) ||
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ) {
        return originalMotion.call(this, fromSlide, toSlide, options);
      }

      const from = getMotionParts(fromSlide);
      const to = getMotionParts(toSlide);
      const direction = options.direction === "previous" ? -1 : 1;

      return {
        leaveControls: () =>
          animateElements([
            {
              element: from.heading,
              keyframes: [
                {
                  opacity: 1,
                  filter: "blur(0)",
                  transform: "translateX(0)"
                },
                {
                  opacity: 0,
                  filter: "blur(4px)",
                  transform: `translateX(${-direction * 18}px)`
                }
              ],
              options: {
                duration: 360,
                easing: "cubic-bezier(0.4, 0, 0.7, 0.2)"
              }
            },
            {
              element: from.image,
              keyframes: [
                {
                  opacity: 1,
                  filter: "blur(0) brightness(1)",
                  transform: "scale(1) translateX(0)"
                },
                {
                  opacity: 0.28,
                  filter: "blur(5px) brightness(0.9)",
                  transform: `scale(1.035) translateX(${-direction * 0.9}%)`
                }
              ],
              options: {
                duration: 480,
                easing: "cubic-bezier(0.45, 0, 0.55, 1)"
              }
            }
          ]),

        enterControls: () =>
          animateElements([
            {
              element: to.image,
              keyframes: [
                {
                  opacity: 0,
                  filter: "blur(9px) brightness(1.1)",
                  transform: `scale(1.078) translateX(${direction * 1.6}%)`
                },
                {
                  opacity: 0.68,
                  filter: "blur(2.5px) brightness(1.035)",
                  transform: `scale(1.025) translateX(${direction * 0.35}%)`,
                  offset: 0.58
                },
                {
                  opacity: 0.94,
                  filter: "blur(0.5px) brightness(1.008)",
                  transform: "scale(1.004) translateX(0)",
                  offset: 0.86
                },
                {
                  opacity: 1,
                  filter: "blur(0) brightness(1)",
                  transform: "scale(1) translateX(0)"
                }
              ],
              options: { duration: 1120, easing: editorialEase }
            },
            {
              element: to.heading,
              keyframes: [
                {
                  opacity: 0,
                  filter: "blur(7px)",
                  transform: `translateX(${direction * 30}px)`
                },
                {
                  opacity: 0.58,
                  filter: "blur(2.5px)",
                  transform: `translateX(${direction * 12}px)`,
                  offset: 0.42
                },
                {
                  opacity: 0.9,
                  filter: "blur(0.6px)",
                  transform: `translateX(${-direction * 1.5}px)`,
                  offset: 0.82
                },
                {
                  opacity: 1,
                  filter: "blur(0)",
                  transform: "translateX(0)"
                }
              ],
              options: {
                duration: 920,
                delay: 150,
                easing: editorialEase
              }
            }
          ])
      };
    };
  });
})();
